module.exports = __webpack_public_path__ + "static/media/video_consent_audio_punjabi.eeceefc9.mp3";